import React from 'react';
import {withStyles} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {getDirectionStyles} from '../../../../../utils/ThemeUtils';

const StyledLabelWrapper = withStyles(theme => ({
    root: {
        margin: getDirectionStyles(theme.direction)(
            theme.spacing(0, 0, 0, 2),
            theme.spacing(0, 2, 0, 0)
        ),

        [theme.breakpoints.up('flg')]: {
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0.9, 0, 0, 2),
                theme.spacing(0.9, 2, 0, 0)
            )
        }
    }
}))(Box);

const StyledLabel = withStyles(theme => ({
    root: {
        textTransform: 'uppercase',
        fontWeight: 400,
        color: theme.palette.dividerStrong
    }
}))(Typography);

export interface HeaderLabelProps {
    label: string;
}

const HeaderLabel: React.FC<HeaderLabelProps> = ({label}: HeaderLabelProps) => (
    <StyledLabelWrapper>
        <StyledLabel variant="body2">{label}</StyledLabel>
    </StyledLabelWrapper>
);

export default HeaderLabel;
